import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  createCategoryThunk,
  updateCategoryThunk,
  fetchCategoriesThunk,
} from "./redux/categoryThunk";
import { setShowForm, setEditingCategory } from "./redux/categorySlice";
import { fetchAllQuestionTypes } from "../BoardMedium/redux/boardQuestionSlice";


export default function CategoryForm() {
  const dispatch = useDispatch();
  const { classes, subjects } = useSelector((state) => state.chapter);

  const [typeName, setTypeName] = useState("");
  const [typeTitle, settypeTitle] = useState("");
  const { editingCategory } = useSelector((state) => state.category);
  //console.log("Editing category:", editingCategory);
  const handleSubmit = async (e) => {
  e.preventDefault();
    const userStr = localStorage.getItem("user");
    const userId = userStr ? JSON.parse(userStr).id : null;
  if (!typeName || !typeTitle) {
    alert("Please fill type name and title.");
    return;
  }

  const payload = {
    type_name: typeName,
    type_title: typeTitle,
    created_by: userId ? userId : null,
    updated_by: userId ? userId : null,
  };

  try {
    if (editingCategory) {
      // Update logic
      await dispatch(updateCategoryThunk({ ...payload, type_id: editingCategory.type_id })).unwrap();
      alert("✅ Type updated successfully!");
    } else {
      // Create logic
      await dispatch(createCategoryThunk(payload)).unwrap();
      alert("✅ Type created successfully!");
    }

    // dispatch(fetchCategoriesThunk());
    dispatch(fetchAllQuestionTypes());
    dispatch(setShowForm(false));
    dispatch(setEditingCategory(null));
  } catch (err) {
    alert("❌ Error: " + err.message || err);
  }
};


  useEffect(() => {
    if (editingCategory) {
      setTypeName(editingCategory.type_name || "");
      settypeTitle(editingCategory.type_title || "");
    } else {
      // If not editing (i.e., creating), clear fields
      setTypeName("");
      settypeTitle("");
    }
  }, [editingCategory, dispatch]);

  const handleCancel = () => {
    dispatch(setShowForm(false));
    dispatch(setEditingCategory(null));
  };

  return (
    <form onSubmit={handleSubmit} style={{ padding: "20px" }}>
      <div style={{ marginBottom: "10px" }}>
        <label>Name:</label>
        <input
          type="text"
          value={typeName}
          onChange={(e) => setTypeName(e.target.value)}
          style={{ width: "100%", padding: "5px" }}
          required
        />
      </div>

      <div style={{ marginBottom: "50px" }}>
        <label>Title:</label>
        <input
          type="text"
          value={typeTitle}
          onChange={(e) => settypeTitle(e.target.value)}
          style={{ width: "100%", padding: "5px" }}
        />
      </div>

      

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
        <button type="button" onClick={handleCancel}>
          Cancel
        </button>
        <button
          type="submit"
          style={{ background: "blue", color: "#fff", padding: "5px 10px" }}
        >
          Save
        </button>
      </div>
    </form>
  );
}
